import { Layout } from '@/components/layout/Layout';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { JobsTab } from './JobsTab';
import { ApplicationsTab } from './ApplicationsTab';

export function Contratacoes() {
  return (
    <Layout breadcrumbs={[{ label: 'Contratações' }]}>
      <div className="flex flex-col gap-4 p-3 sm:p-4 lg:gap-6 lg:p-6">
        <div>
          <h1 className="max-md:hidden text-2xl font-bold tracking-tight text-text-title sm:text-3xl">
            Contratações
          </h1>
          <p className="mt-1 text-sm text-text-secondary">
            Vagas publicadas e candidaturas recebidas no site.
          </p>
        </div>

        <Tabs defaultValue="vagas">
          <TabsList>
            <TabsTrigger value="vagas">Vagas</TabsTrigger>
            <TabsTrigger value="candidaturas">Candidaturas</TabsTrigger>
          </TabsList>

          <TabsContent value="vagas">
            <JobsTab />
          </TabsContent>

          <TabsContent value="candidaturas">
            <ApplicationsTab />
          </TabsContent>
        </Tabs>
      </div>
    </Layout>
  );
}
